export default __webpack_public_path__ + "static/media/en-1.7a989d87.jpg";